import React, { useRef } from 'react';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import { useOnScreenTelemetry } from '@hooks/useOnScreenTelemetry';
import { findAnEventPageData } from '@data-ts/pages/find-an-event';
import { TOP_SECTION_BRANDS, BOTTOM_SECTION_BRANDS } from './BrandsSectionConstants';
import {
  BrandsWrapper,
  Container,
  DesktopBrandLogo,
  BrandItemWrapper,
  MobileBrandLogo,
  StyledText,
  TextWrapper,
} from './BrandsSection.styles';

const SECTION_ID = 'FindAnEvent_Brands_Section';

export const BrandsSection: React.FC = () => {
  const brandsSectionRef = useRef<HTMLDivElement>(null);

  useOnScreenTelemetry(brandsSectionRef, SECTION_ID);

  const { brandSection } = findAnEventPageData;
  return (
    <Container id={SECTION_ID} ref={brandsSectionRef}>
      <TextWrapper>
        <StyledText tagName="div" variant="hed56" color="neutra5">
          {brandSection?.title}
        </StyledText>
        <CloudImage src="find-an-event/logotypes_instyle.png" width="132px" />
      </TextWrapper>
      <BrandsWrapper>
        <BrandItemWrapper>
          {TOP_SECTION_BRANDS.map(brand => (
            <Flex key={brand.id} justifyContent="center">
              <MobileBrandLogo style={brand.style?.mobile} src={brand.pathMobile} />
              <DesktopBrandLogo src={brand.pathDesktop} />
            </Flex>
          ))}
        </BrandItemWrapper>
        <BrandItemWrapper>
          {BOTTOM_SECTION_BRANDS.map(brand => (
            <Flex key={brand.id} justifyContent="center">
              <MobileBrandLogo style={brand.style?.mobile} src={brand.pathMobile} />
              <DesktopBrandLogo src={brand.pathDesktop} />
            </Flex>
          ))}
        </BrandItemWrapper>
      </BrandsWrapper>
    </Container>
  );
};
